<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style>
html {
  height: 100%;
}
body {
  min-height: 100%;
}
</style>
